<template>
    <el-table
    :data="tableData" 
    
    >
    <el-table-column
        v-for="(val,index) in tableTitle" :key="index"
        :prop="val.prop"
        :label="val.label"
        >
        <template slot-scope="scope">
            <el-image :preview-src-list="[scope.row[val.prop]]" v-if="isImg(scope.row[val.prop])" style="width:80px;height:80px;border:none;"  :src="scope.row[val.prop]"></el-image>
            <div v-else>
                <div v-if="val.is_turn">{{get_status(scope.row[val.prop])}}</div>
                <div v-else-if="val.is_turn2">{{val.fun(scope.row[val.prop])}}</div>
                <div v-else>{{scope.row[val.prop]}}</div>
            </div>
        </template>
    </el-table-column>
    <el-table-column
      fixed="right"
      label="操作"
      min-width="100">
      <template name="scope" slot-scope="scope">
          <el-button v-for="(item,index) in btnList" :key="index" v-if="item.acces_id?hasAccess(item.acces_id):true"
          @click="item.fun(scope.row)" type="text" size="small"
          >{{item.btn}}
          </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { hasAccess } from '@/common/utils'
export default {
    props:{
        tableData:Array, //表格数据
        tableTitle:Array, //表格表头
        btnList:Array, //表格按钮
        get_status_fun:Function
    },
    data(){
        return{
            hasAccess
        }
    },
    methods:{
        get_status(val) {
            if(this.get_status_fun){
                return this.get_status_fun(val)
            }else{
                switch(val) {
                    case '0':
                        return '未审核'
                    case '1':
                        return '已审核'
                    case '-1':
                        return '已驳回'
                    case '-2':
                        return '已撤销'
                    default:
                        // 默认代码块
                        return val
                } 
            }
        },
        isImg(url) {
           if(!/\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(url)){
               return false
           }else{
               return true
           }
        },
        handleClick(e){
            console.log(e)
        }
    }
}
</script>
